import { Button, Form, InputField, Modal } from "@myloc/myloc-gui";
import PropType from "prop-types";
import { useEffect, useState } from "react";
import { useTranslate } from "../../../language/i18n";
import { setError } from "../../../reducers/dialog/dialogAction";
import clientService from "../../../services/client/clientService";
import isEqual from "../../../utils/compareObjects";
import { AdvanceContactInformation } from "../../shared/RecieverInformation/RecieverInformation";
import styles from "../ClientsPage.module.scss";

const validatePhoneNumber = phoneNumber => {
  if (!phoneNumber) {
    return null;
  }

  const regex = /^\+?[0-9]{1,19}$|^[0-9]{1,20}$/;
  if (!regex.test(phoneNumber)) {
    return "INVALID_PHONE_NUMBER";
  }
  return null;
};

const EditClientModal = ({ visible, client, onClose, setFetchReceiver }) => {
  const translate = useTranslate();
  const [contactInfo, setContactInfo] = useState({
    phoneNo: client.contactInformation?.phoneNo,
    email: client.contactInformation?.email,
  });
  const [loading, setLoading] = useState(false);
  const [useAdvanceContact, setUseAdvanceContact] = useState(client.useAdvanceContact);
  const [showRequired, setShowRequired] = useState(false);

  useEffect(() => {
    setContactInfo({ phoneNo: client.contactInformation?.phoneNo, email: client.contactInformation?.email });
    setUseAdvanceContact(client.useAdvanceContact);
  }, [client]);

  const handleFieldChange = (event, key) => {
    setContactInfo({ ...contactInfo, [key]: event.target.value });
  };
  const handleSubmit = () => {
    const validationError = validatePhoneNumber(contactInfo.phoneNo);

    if (validationError) {
      setError({ errorMessage: translate(validationError) });
      return;
    }

    if (useAdvanceContact == null) {
      setShowRequired(true);
      return;
    }

    if (
      contactInfo &&
      isEqual(client.contactInformation, contactInfo) &&
      client.useAdvanceContact === useAdvanceContact
    ) {
      onClose();
    } else {
      setLoading(true);
      clientService.updateClient(client.id, { contactInformation: contactInfo, useAdvanceContact }).then(() => {
        setLoading(false);
        setFetchReceiver(true);
        setShowRequired(false);
        onClose();
      });
    }
  };

  return (
    <Modal visible={visible} title={translate("EDIT_CLIENT")} onClose={onClose} customCssClass={styles.modal}>
      <Form onSubmit={handleSubmit} className={styles.form}>
        <InputField
          label={translate("PHONE_NO")}
          name="phoneNo"
          type="text"
          value={contactInfo?.phoneNo}
          onChange={e => handleFieldChange(e, "phoneNo")}
          autoFocus
        />
        <InputField
          label={translate("EMAIL")}
          name="email"
          type="text"
          value={contactInfo?.email}
          onChange={e => handleFieldChange(e, "email")}
        />
        <AdvanceContactInformation
          onChange={setUseAdvanceContact}
          shouldContact={useAdvanceContact}
          showRequired={showRequired}
        />
        <Button type="submit" isLoading={loading} customCssClass={styles.saveBtn}>
          {translate("SAVE")}
        </Button>
      </Form>
    </Modal>
  );
};

EditClientModal.propTypes = {
  visible: PropType.bool,
  client: PropType.shape({
    id: PropType.string,
    contactInformation: PropType.shape({
      phoneNo: PropType.string,
      email: PropType.string,
    }),
    useAdvanceContact: PropType.bool,
  }),
  onClose: PropType.func,
  setFetchReceiver: PropType.func,
};

export default EditClientModal;
